import { Link } from "react-router-dom";
import type { CategoryRelated } from "@/data/content";

export default function RelatedLinks({ items }: { items: CategoryRelated[] }) {
  return (
    <div className="flex flex-wrap gap-2.5">
      {items.map((item) => (
        <Link
          key={`${item.label}-${item.href}`}
          to={item.href}
          className="inline-flex items-center gap-2 text-sm font-medium text-foreground-700 bg-background-50 border border-background-300 rounded-md px-4 py-2.5 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {item.label}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      ))}
    </div>
  );
}